export default __webpack_public_path__ + "static/media/1935.8332cf38.png";